import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SidenavLayoutConfig } from './_models/sidenav-layout-config.model';
import { ToggleSidenavService } from '../_services/toggle-sidenav.service';
import { ISidenavMenuItem } from '../_models/sidenav-menu-item.interface';
import { SidenavMenuItem } from '../_models/sidenav-menu-item.model';

/**
 * A layout component that includes a sidenav
 */
@Component({
  selector: 'lm-sidenav-layout',
  templateUrl: './sidenav-layout.component.html',
  styleUrls: ['./sidenav-layout.component.scss']
})
export class SidenavLayoutComponent implements OnInit {
  /** A layout config object */
  public layoutConfig: SidenavLayoutConfig;

  /** Boolean indicating whether the sidenav is open */
  public sideNavIsOpen = false;

  /** Boolean indicating whether the component data is initialized */
  public initialized = false;

  /** The component's menu items */
  public menuItems: ISidenavMenuItem[] = [];

  /**
   * @param toggleSidenavService - A reference to the toggle service
   * @param route - A reference to the activated route
   */
  constructor(
    private toggleSidenavService: ToggleSidenavService,
    private route: ActivatedRoute
  ) {}

  /**
   * Method called when the component is initialized
   */
  public ngOnInit() {
    this.route.data.subscribe((data: SidenavLayoutConfig) => {
      this.layoutConfig = data;
      this.menuItems = this.layoutConfig.sidenav.menuItems;
      this.initialized = true;
    });
    this.toggleSidenavService.isToggled.subscribe(
      result => (this.sideNavIsOpen = result)
    );
  }

  /**
   * Add a menu item
   * @param menuItem - The menu item to add
   */
  public asSidenavMenuItem(menuItem: ISidenavMenuItem): SidenavMenuItem {
    return <SidenavMenuItem>menuItem;
  }

  /**
   * Close the sidenav
   */
  public closeSideNav() {
    this.toggleSidenavService.toggleMenu(false);
  }
}
